module.exports = __webpack_public_path__ + "img/t6.aace79e8.jpeg";